var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"string-item",class:{ 'string-item--disabled': _vm.disabled, 'string-item--modal': _vm.modal }},[_c('div',{staticClass:"param-checkbox",class:{
      'param-checkbox--checked': _vm.checked,
      'param-checkbox--disabled': _vm.disabled,
      'param-checkbox--modal': _vm.modal
    },on:{"click":function($event){!_vm.disabled && _vm.$emit('change', !_vm.item)}}}),_vm._v(" "),_c('div',{staticClass:"string-item__text",on:{"click":function($event){_vm.clickableLabel && !_vm.disabled && _vm.$emit('change', !_vm.item); _vm.$emit('click-label')},"":function($event){}}},[_vm._v("\n    "+_vm._s(_vm.item)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }